import {mapClass} from "../utils";
import {FileProgress} from "./fileprogress";
import {SWFUpload, SWFUploaderInstance, SWFUploadFile, SWFUploadParams} from "./swfuploader";

/*  the methods defined here are exported below by assigning them to window. This odd api is due to a backwards compatibilty requirement.*/

function uploadError(this: SWFUploaderInstance, file: SWFUploadFile, errorCode: number, message: string) {
	try {
		const progress = new FileProgress(file, this.custom_settings.progressTarget);
		progress.setError();
		progress.toggleCancel(false);

		switch (errorCode) {
			case SWFUpload.UPLOAD_ERROR.HTTP_ERROR:
				progress.setStatus("Upload Error: " + message);
				break;
			case SWFUpload.UPLOAD_ERROR.UPLOAD_FAILED:
				progress.setStatus("Upload Failed.");
				break;
			case SWFUpload.UPLOAD_ERROR.IO_ERROR:
				progress.setStatus("Server (IO) Error");
				break;
			case SWFUpload.UPLOAD_ERROR.SECURITY_ERROR:
				progress.setStatus("Security Error");
				break;
			case SWFUpload.UPLOAD_ERROR.UPLOAD_LIMIT_EXCEEDED:
				progress.setStatus("Upload limit exceeded.");
				break;
			case SWFUpload.UPLOAD_ERROR.FILE_VALIDATION_FAILED:
				progress.setStatus("Failed Validation.  Upload skipped.");
				break;
			case SWFUpload.UPLOAD_ERROR.FILE_CANCELLED:
				// If there aren't any files left (they were all cancelled) disable the cancel button
				if (this.getStats().files_queued === 0) {
					const button = document.getElementById(this.custom_settings.cancelButtonId)
					if (button && button instanceof HTMLInputElement || button instanceof HTMLButtonElement)
						button.disabled = true;
				}
				progress.setStatus("Cancelled");
				progress.setCancelled();
				break;
			case SWFUpload.UPLOAD_ERROR.UPLOAD_STOPPED:
				progress.setStatus("Stopped");
				break;
			default:
				progress.setStatus("Unhandled Error: " + errorCode);
				break;
		}
	} catch (ex) {
	}
}

function fileQueueError(this: SWFUploadParams, file: SWFUploadFile, errorCode: number|string, message: string|number) {
	try {
		if (errorCode === SWFUpload.QUEUE_ERROR.QUEUE_LIMIT_EXCEEDED) {
			alert("You have attempted to queue too many files.\n" + (message === 0 ? "You have reached the upload limit." : "You may select " + (message > 1 ? "up to " + message + " files." : "one file.")));
			return;
		}

		const progress = new FileProgress(file, this.custom_settings.progressTarget);
		progress.setError();
		progress.toggleCancel(false);

		switch (errorCode) {
			case SWFUpload.QUEUE_ERROR.FILE_EXCEEDS_SIZE_LIMIT:
				progress.setStatus("File is too big.");
				break;
			case SWFUpload.QUEUE_ERROR.ZERO_BYTE_FILE:
				progress.setStatus("Cannot upload Zero Byte files.");
				break;
			case SWFUpload.QUEUE_ERROR.INVALID_FILETYPE:
				progress.setStatus("Invalid File Type.");
				break;
			default:
				if (file !== null) {
					progress.setStatus("Unhandled Error");
				}
				break;
		}
	} catch (ex) {
	}
}

function fileQueued(this: SWFUploaderInstance, file: SWFUploadFile) {
	try {
		const progress = new FileProgress(file, this.custom_settings.progressTarget);
		progress.setStatus("Pending...");
		progress.toggleCancel(true, this);

	} catch (ex) {
	}
}

function uploadStart(this: SWFUploaderInstance, file: SWFUploadFile) {
	try {
		/* I don't want to do any file validation or anything,  I'll just update the UI and
		return true to indicate that the upload should start.
		It's important to update the UI here because in Linux no uploadProgress events are called. The best
		we can do is say we are uploading.
		 */
		const progress = new FileProgress(file, this.custom_settings.progressTarget);
		progress.setStatus("Uploading...");
		progress.toggleCancel(true, this);
	}
	catch (ex) {}

	return true;
}

function uploadProgress(this: SWFUploadParams, file: SWFUploadFile, bytesLoaded: number, bytesTotal: number) {
	try {
		const percent = Math.ceil((bytesLoaded / bytesTotal) * 100);

		const progress = new FileProgress(file, this.custom_settings.progressTarget);
		progress.setProgress(percent);
		progress.setStatus("Uploading...");
	} catch (ex) {
	}
}

// the next functions are used from php code. i cannot warrant their necessity or utility.
function fileDialogComplete() {}

function uploadSuccess(this: SWFUploaderInstance, file: SWFUploadFile) {
	try {
		const progress = new FileProgress(file, this.custom_settings.progressTarget);
		progress.setComplete();
		progress.setStatus("Complete.");
		progress.toggleCancel(false);

	} catch (ex) {
	}
}

function uploadComplete(this: SWFUploaderInstance) {
	if (this.getStats().files_queued === 0) {
		mapClass(document.getElementById(this.custom_settings.cancelButtonId), HTMLButtonElement, e => e.disabled = true);
	}
}

// This event comes from the Queue Plugin
function queueComplete(numFilesUploaded: number) {
	const status = document.getElementById("divStatus");
	if(status) {
		status.innerHTML = numFilesUploaded + " file" + (numFilesUploaded === 1 ? "" : "s") + " uploaded.";
	}
}

//these are accessed from php code. we use this rather than direct exports because php code excepts to be able to change them.
;(window as any).uploadError = uploadError
;(window as any).fileQueueError = fileQueueError
;(window as any).fileQueued = fileQueued
;(window as any).uploadStart = uploadStart
;(window as any).uploadProgress = uploadProgress
;(window as any).fileDialogComplete = fileDialogComplete
;(window as any).uploadSuccess = uploadSuccess
;(window as any).uploadComplete = uploadComplete
;(window as any).queueComplete = queueComplete

export const done = true



// WEBPACK FOOTER //
// ./src/lib/swfuploader/handler.ts